import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  unsecured_cash_borrowing: {
    name: 'Unsecured cash borrowing',
    order: 283
  },
  secured_borrowing_prime_brokerage: {
    name: 'Collaterised/secured cash borrowing prime broker amount',
    order: 284
  },
  secured_borrowing_reverse_repo: {
    name: 'Collaterised/secured cash borrowing reverse repo amount',
    order: 285
  },
  secured_borrowing_other: {
    name: 'Collaterised/secured cash borrowing other amount',
    order: 286
  }
};

export function Borrowing({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.BORROWING_DETAILS,
    onChangeFund,
    schema: schema.BORROWING_DETAILS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.BORROWING_DETAILS?.field_names || [],
    columnLables,
    tableName: 'BORROWING_DETAILS',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="reporttables-borrowing-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
